module.exports = __webpack_public_path__ + "media/images/creator/home/kv-bg@3x-3385d5a87cb2b357ed29f6ea011ca65f.png";